import * as React from 'react';
import TestProjectsPage from '../screens/TestProjectsPage';
import TestProjectDashboardPage from '../screens/TestProjectDashboardPage';
import { monitorRouterMatch, ProtectedRoute } from '../../common/components';
import { STORE_TEST_PROJECT_DASHBOARD, STORE_TEST_PROJECT_RUN_COMPARE } from '../stores/constants';
import TestProjectBaselinesPage from '../screens/TestProjectBaselinesPage';
import TestProjectRunResultPage from '../screens/TestProjectRunResultPage';
import TestProjectRunTopicPreviewPage from '../screens/TestProjectRunTopicPreviewPage';
import TestProjectRunComparePage from '../screens/TestProjectRunComparePage';

export const TestProjectsNavigation = {
    TestProjectsPage: '/projects/:projectId/test-projects',
    TestProjectDashboardPage: '/projects/:projectId/test-project-dashboard/:testProjectId',
    TestProjectBaselinesPage: '/projects/:projectId/test-project-baselines/:testProjectId',
    TestProjectRunResultsPage: '/projects/:projectId/test-project/:testProjectId/run-results/:runId',
    TestProjectRunTopicPreviewsPage: '/projects/:projectId/test-project/:testProjectId/preview/',
    TestProjectRunComparePage: '/projects/:projectId/test-project/:testProjectId/run-compare/:firstRunId/:secondRunId'
};

export default () => {
    return (
        <>
            <ProtectedRoute component={TestProjectsPage} path={TestProjectsNavigation.TestProjectsPage} />
            <ProtectedRoute
                component={monitorRouterMatch(
                    STORE_TEST_PROJECT_DASHBOARD,
                    (s, m) => s[STORE_TEST_PROJECT_DASHBOARD].matchCurrentTestProjectData(m!.params),
                    { updateOnParamsChange: true }
                )(TestProjectDashboardPage)}
                path={TestProjectsNavigation.TestProjectDashboardPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(
                    STORE_TEST_PROJECT_DASHBOARD,
                    (s, m) => s[STORE_TEST_PROJECT_DASHBOARD].matchCurrentTestProjectData(m!.params),
                    { updateOnParamsChange: true }
                )(TestProjectBaselinesPage)}
                path={TestProjectsNavigation.TestProjectBaselinesPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(
                    STORE_TEST_PROJECT_DASHBOARD,
                    (s, m) => s[STORE_TEST_PROJECT_DASHBOARD].matchCurrentTestProjectData(m!.params),
                    { updateOnParamsChange: true }
                )(TestProjectRunResultPage)}
                path={TestProjectsNavigation.TestProjectRunResultsPage}
            />
            <ProtectedRoute
                component={TestProjectRunTopicPreviewPage}
                path={TestProjectsNavigation.TestProjectRunTopicPreviewsPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(
                    STORE_TEST_PROJECT_RUN_COMPARE,
                    (s, m) => s[STORE_TEST_PROJECT_RUN_COMPARE].matchCurrentRunCompareData(m!.params),
                    { updateOnParamsChange: true }
                )(TestProjectRunComparePage)}
                path={TestProjectsNavigation.TestProjectRunComparePage}
            />
        </>
    );
};
